import React from 'react';
import {
  Box,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
} from '@mui/material';

import { useNavigate, useLocation, Outlet } from 'react-router-dom';

import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'; // 👈 ADD THIS IMPORT

import Header from './Header';

export default function DeliveryLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const getNavValue = () => {
    if (
      location.pathname === '/dashboard' ||
      location.pathname.startsWith('/batch') ||
      location.pathname.startsWith('/order/') // 👈 FIXED: Added trailing slash
    )
      return 0;

    if (location.pathname === '/orders') return 1; 
    if (location.pathname === '/DeliveryAccount') return 2;

    return 0;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#F8F9FA'
      }}
    >

      {/* HEADER */}
      <Header />

      {/* PAGE CONTENT */}
      <Box
        sx={{
          flex: 1,
          pb: '90px',
          pt: '10px'
        }}
      >
        <Outlet />
      </Box>

      {/* BOTTOM NAV */}
      <Paper
        elevation={10}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          overflow: 'hidden',
          zIndex: 1000
        }}
      >
        <BottomNavigation
          value={getNavValue()}
          showLabels
          sx={{
            height: 70,
            '& .Mui-selected': {
              color: '#FF4B2B !important',
              fontWeight: 'bold'
            }
          }}
        >

          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon />}
            onClick={() => navigate('/dashboard')}
          />
          
          {/* 👇 ADD ORDERS ACTION 👇 */}
          <BottomNavigationAction
            label="Orders"
            icon={<ReceiptLongIcon />}
            onClick={() => navigate('/orders')}
          />

          <BottomNavigationAction
            label="Account"
            icon={<PersonIcon />}
            onClick={() => navigate('/DeliveryAccount')}
          />

        </BottomNavigation>
      </Paper>
    </Box>
  );
}